export const productModule = {

    state() {
        return {
            product: null,
            similarProducts: []
        }
    },

    getters: {
        product(state) {
            return state.product
        },
        similarProducts(state) {
            return state.similarProducts
        }
    },

    mutations: {
        setProduct(state, data) {
            state.product = data
        },
        setSimilarProducts(state, data) {
            state.similarProducts = data
        }
    },

    actions: {
        async getProduct({ commit }, data) {
            await axios.get('/api/product/' + data.slug).then((res) => {
                commit('setProduct', res.data.data)
            }).catch((err) => {

            })
        },
        async getSimilarProducts({ commit }, data) {
            await axios.get('/api/similar-products/' + data.slug).then((res) => {
                commit('setSimilarProducts', res.data.data)
            }).catch((err) => {

            })
        },
    },

    namespaced: true,
};